<div
  class="cm-content-skeleton"
  role="status"
  aria-live="polite"
  aria-busy="true"
>
  <claas-skeleton variant="rectangular" width="100%" height="280px" />
  <claas-skeleton variant="rectangular" width="45%" height="1.5rem" />
  <claas-skeleton variant="text" [lines]="3" />
</div>
